// File: src/components/FeedbackWidget.jsx
import React, { useContext, useState } from 'react';
import { Fab, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Stack } from '@mui/material';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { createAuthenticatedAPI } from '../utils/apiClient';
import { AuthContext } from '../context/AuthContext';

const types = ['Bug', 'Idea', 'Confusion', 'Other'];

const FeedbackWidget = () => {
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('Bug');
  const [message, setMessage] = useState('');
  const api = createAuthenticatedAPI({ user, logout });

  const submit = async () => {
    try {
      await api.post('/feedback', {
        type,
        message,
        page: window.location.href,
        user_agent: navigator.userAgent,
        metadata: {}
      });
      setOpen(false);
      setMessage('');
      setType('Bug');
      alert('Thanks! Your feedback was sent.');
    } catch (e) {
      alert('Failed to send feedback. Please try again.');
    }
  };

  return (
    <>
      <Fab
        color="primary"
        aria-label="feedback"
        onClick={() => setOpen(true)}
        sx={{ position: 'fixed', right: 16, bottom: 16, zIndex: 2000 }}
      >
        <FeedbackIcon />
      </Fab>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Send Feedback</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField select label="Type" value={type} onChange={(e) => setType(e.target.value)} size="small">
              {types.map((t) => (
                <MenuItem key={t} value={t}>{t}</MenuItem>
              ))}
            </TextField>
            <TextField
              label="Your feedback"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              multiline
              minRows={4}
              placeholder="Describe the bug/idea/confusion. Include steps if relevant."
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={submit} disabled={!message.trim()}>Send</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FeedbackWidget;


